import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchTopChartsData,
  fetchNewAppsData,
  fetchMoverData,
  fetchLoserData,
  fetchCategoryRankingsData,
} from './rankingThunk';
import { IRankingData, IRankingCategoryData } from '@models/ranking/rankingModle';
import { tabList } from '@models/ranking/ranking';

const initialState = {
  topCharts: null as IRankingData,
  topChartsRequestStatus: '',
  categoryRankings: null as IRankingCategoryData,
  isLoadingCategoryRankings: false,
  categoryTabValue: tabList[0].code as 'myAppData' | 'competitionData', // 탭 선택
  categoriesSelected: [], //카테고리 선택
  biggestMover: null as IRankingData,
  biggestMoverRequestStatus: '',
  biggestLoser: null as IRankingData,
  biggestLoserRequestStatus: '',
  newApps: null as IRankingData,
  newAppsRequestStatus: '',
};

export const rankingSlice = createSlice({
  name: 'ranking',
  initialState: initialState,
  reducers: {
    setTabValue: (state, { payload }: { payload: { tabValue: 'myAppData' | 'competitionData' } }) => {
      state.categoryTabValue = payload.tabValue;
    },
    setSelectCategory: (state, { payload }: { payload: { categoryList: string[] } }) => {
      state.categoriesSelected = payload.categoryList;
    },
    addSelectCategory: (state, { payload }: { payload: { category: string } }) => {
      state.categoriesSelected = state.categoriesSelected.concat(payload.category);
    },
    delSelectCategory: (state, { payload }: { payload: { category: string } }) => {
      state.categoriesSelected = state.categoriesSelected.filter((item) => item !== payload.category);
    },
  },
  extraReducers: {
    // top charts
    [fetchTopChartsData.fulfilled.type]: (state, { payload, meta: { requestStatus } }) => {
      state.topCharts = payload;
      state.topChartsRequestStatus = requestStatus;
    },
    [fetchTopChartsData.pending.type]: (state, { meta: { requestStatus } }) => {
      state.topChartsRequestStatus = requestStatus;
    },
    [fetchTopChartsData.rejected.type]: (state, { meta: { requestStatus } }) => {
      state.topChartsRequestStatus = requestStatus;
    },

    // categoryRankings
    [fetchCategoryRankingsData.pending.type]: (state, { payload, meta: { requestStatus } }) => {
      state.isLoadingCategoryRankings = true;
    },
    [fetchCategoryRankingsData.fulfilled.type]: (state, { payload, meta: { requestStatus } }) => {
      state.isLoadingCategoryRankings = false;
      state.categoryRankings = payload;
    },

    // biggest Mover
    [fetchMoverData.fulfilled.type]: (state, { payload, meta: { requestStatus } }) => {
      state.biggestMover = payload;
      state.biggestMoverRequestStatus = requestStatus;
    },
    [fetchMoverData.pending.type]: (state, { meta: { requestStatus } }) => {
      state.biggestMoverRequestStatus = requestStatus;
    },
    [fetchMoverData.rejected.type]: (state, { meta: { requestStatus } }) => {
      state.biggestMoverRequestStatus = requestStatus;
    },

    // biggest Loser
    [fetchLoserData.fulfilled.type]: (state, { payload, meta: { requestStatus } }) => {
      state.biggestLoser = payload;
      state.biggestLoserRequestStatus = requestStatus;
    },
    [fetchLoserData.pending.type]: (state, { meta: { requestStatus } }) => {
      state.biggestLoserRequestStatus = requestStatus;
    },
    [fetchLoserData.rejected.type]: (state, { meta: { requestStatus } }) => {
      state.biggestLoserRequestStatus = requestStatus;
    },

    // new apps
    [fetchNewAppsData.fulfilled.type]: (state, { payload, meta: { requestStatus } }) => {
      state.newApps = payload;
      state.newAppsRequestStatus = requestStatus;
    },
    [fetchNewAppsData.pending.type]: (state, { meta: { requestStatus } }) => {
      state.newAppsRequestStatus = requestStatus;
    },
    [fetchNewAppsData.rejected.type]: (state, { meta: { requestStatus } }) => {
      state.newAppsRequestStatus = requestStatus;
    },
  },
});

export const { setSelectCategory, setTabValue, addSelectCategory, delSelectCategory } = rankingSlice.actions;
export const rankingSliceName = rankingSlice.name;
export default rankingSlice.reducer;
